var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { XForm } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
import { Service, Inject } from "@bluelibs/core";
import { features } from "./features";
import { CompaniesCollection, BanksCollection, BankAccountsCollection, } from "@bundles/UIAppBundle/collections";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
let BankAccountCreateForm = class BankAccountCreateForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "currency",
                label: t("management.bank_accounts.fields.currency"),
                name: ["currency"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Select, { options: Object.keys(BankAccountCurrency).map((key) => ({
                            label: key,
                            value: key,
                        })) }, void 0) }), void 0)),
            },
            {
                id: "accountNumber",
                label: t("management.bank_accounts.fields.accountNumber"),
                name: ["accountNumber"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "initialBalance",
                label: t("management.bank_accounts.fields.initialBalance"),
                name: ["initialBalance"],
                required: true,
                component: Ant.InputNumber,
            },
            {
                id: "companyId",
                label: t("management.bank_accounts.fields.company"),
                name: ["companyId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0)),
            },
            {
                id: "bankId",
                label: t("management.bank_accounts.fields.bank"),
                name: ["bankId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BanksCollection, field: "name", required: true }, void 0) }), void 0)),
            },
        ]);
    }
    onSubmit(document) {
        const { t } = this.i18n;
        return this.collection
            .insertOne(document)
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.bank_accounts.create_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            if (features.view) {
                return this.router.go(Routes.BANK_ACCOUNTS_VIEW, {
                    params: {
                        id: _id,
                    },
                });
            }
            if (features.list) {
                return this.router.go(Routes.BANK_ACCOUNTS_LIST);
            }
            if (features.edit) {
                return this.router.go(Routes.BANK_ACCOUNTS_EDIT, {
                    params: {
                        id: _id,
                    },
                });
            }
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => BankAccountsCollection),
    __metadata("design:type", typeof (_a = typeof BankAccountsCollection !== "undefined" && BankAccountsCollection) === "function" ? _a : Object)
], BankAccountCreateForm.prototype, "collection", void 0);
BankAccountCreateForm = __decorate([
    Service({ transient: true })
], BankAccountCreateForm);
export { BankAccountCreateForm };
